import React, { useEffect, useState } from "react";
import { IoIosPersonAdd } from "react-icons/io";

import { RotatingLines } from "react-loader-spinner";
import { useGlobalContext } from "../../context/stateContext";


const CashierSales = () => {
  const {activeSession} = useGlobalContext();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dateValue, setDateValue] = useState("");  
  const [showDateRanges, setShowDateRanges] = useState(false);
  const [session, setSession] = useState("Consolidated");
  const [loading, setLoading] = useState(false);
  
  const branch= (activeSession?.branch?.id);
  

  const getDateRange = (value) => {
    let start_date = "";
    let end_date = "";
    if (value === "Today") {
        setShowDateRanges(false);
      start_date = formatDate(new Date());
      end_date = formatDate(new Date());
    } else if (value === "Yesterday") {
        setShowDateRanges(false);
      start_date = formatDate(
        new Date(new Date().setDate(new Date().getDate() - 1))
      );
      end_date = formatDate(
        new Date(new Date().setDate(new Date().getDate() - 1))
      );
    } else if (value === "Last 7 Days") {
        setShowDateRanges(false);
      start_date = formatDate(
        new Date(new Date().setDate(new Date().getDate() - 7))
      );
      end_date = formatDate(new Date());
    } else if (value === "Last 30 Days") {
        setShowDateRanges(false);
      start_date = formatDate(
        new Date(new Date().setDate(new Date().getDate() - 30))
      );
      end_date = formatDate(new Date());
    } else if (value === "This Month") {
        setShowDateRanges(false);
      start_date = formatDate(new Date(new Date().setDate(1)));
      end_date = formatDate(new Date());
    } else if (value === "Last Month") {
        setShowDateRanges(false);
      start_date = formatDate(
        new Date(new Date().setMonth(new Date().getMonth() - 1))
      );
      end_date = formatDate(
        new Date(new Date().setMonth(new Date().getMonth() - 1))
      );
    } else if (value === "This Year") {
        setShowDateRanges(false);
      start_date = formatDate(new Date(new Date().setMonth(0)));
      end_date = formatDate(new Date());
    } else if (value === "Last Year") {
        setShowDateRanges(false);
      start_date = formatDate(
        new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      );
      end_date = formatDate(
        new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      );
    } else if (value === "Custom") {
      setShowDateRanges(true);
      // setStartDate(formatDate(new Date()));
      // setEndDate(new Date());
    }
    setStartDate(start_date);
    setEndDate(end_date);
    const strDateValue = `${start_date} - ${end_date}`;
    setDateValue(strDateValue);
  };
  // FORMAT DATE
  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

 

  const getCashierSales = async () => {
    
    
    window.location.href = `/sales/cashier/print?session=${session}&branch=${branch}&start_date=${startDate}&end_date=${endDate}`
  };
  useEffect(() => {
    
    getDateRange("Last 30 Days");
  }, []);
  return (
    <div className="px-[20px] pb-[200px]">
      <div className="py-[32px] flex items-center gap-3">
        <IoIosPersonAdd className="text-[19px]" />
        <h4 className="text-[19px]">
          <b>Transaction</b> list
        </h4>
      </div>

      <div className="lg:w-[40%] mx-auto">
        <div className="">
          <div className="mb-[20px] border border-[#ddd] rounded-[3px] bg-white">
            <div className="p-[20px]">
              <h5 className="my-[2px] text-[17px]">
                Transaction List
              </h5>
            </div>
            <div className="p-[20px] pt-0">
              <div className="flex items-center gap-2 mb-[20px] pb-[10px] uppercase border-b border-[#e5e5e5]">
                <IoIosPersonAdd className="text-[12px]" />
                <label htmlFor="item" className="text-[12px] font-[500]">
                  Sale Details
                </label>
              </div>

              <div className="mb-[20px]">
                  <label htmlFor="" className="font-[600]">
                  Session:
                  </label>
                  <select
                  onChange={(e) => setSession(e.target.value)}
                  id=""
                  className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                  >
                  <option value="Consolidated" selected>
                      Consolidated
                  </option>
                  <option value="Morning">Morning Session</option>
                  <option value="Evening">Evening Session</option>
                  </select>
              </div>
              
              {/* <div className="mb-[20px]">
                <label htmlFor="" className="font-[600]">
                  Date:
                </label>
                <div className="relative">
                  <input
                    name=""
                    value={dateValue}
                    id=""
                    onClick={() => setShowDropdown(!showDropdown)}
                    className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                  />
                  {showDropdown && (
                    <ul className="absolute top-10 w-[200px] right-0 left-0 bg-white py-[7px] min-w-[180px] border border-[#ddd] text-left text-[12px]">
                      <li
                        className="py-[8px] px-[12px] cursor-pointer hover:bg-[#26A69A] hover:text-white"
                        onClick={() => {
                          getDateRange("Today");
                          setShowDropdown(false);
                        }}
                      >
                        Today
                      </li>
                      <li
                        className="py-[8px] px-[12px] cursor-pointer hover:bg-[#26A69A] hover:text-white"
                        onClick={() => {
                          getDateRange("Yesterday");
                          setShowDropdown(false);
                        }}
                      >
                        Yesterday
                      </li>
                      <li
                        className="py-[8px] px-[12px] cursor-pointer hover:bg-[#26A69A] hover:text-white"
                        onClick={() => {
                          getDateRange("Last 7 Days");
                          setShowDropdown(false);
                        }}
                      >
                        Last 7 Days
                      </li>
                      <li
                        className="py-[8px] px-[12px] cursor-pointer hover:bg-[#26A69A] hover:text-white"
                        onClick={() => {
                          getDateRange("Last 30 Days");
                          setShowDropdown(false);
                        }}
                      >
                        Last 30 Days
                      </li>
                      <li
                        className="py-[8px] px-[12px] cursor-pointer hover:bg-[#26A69A] hover:text-white"
                        onClick={() => {
                          getDateRange("This Month");
                          setShowDropdown(false);
                        }}
                      >
                        This Month
                      </li>
                      <li
                        className="py-[8px] px-[12px] cursor-pointer hover:bg-[#26A69A] hover:text-white"
                        onClick={() => {
                          getDateRange("Last Month");
                          setShowDropdown(false);
                        }}
                      >
                        Last Month
                      </li>
                      <li
                        className="py-[8px] px-[12px] cursor-pointer hover:bg-[#26A69A] hover:text-white"
                        onClick={() => {
                          getDateRange("Custom");
                          setShowDropdown(false);
                        }}
                      >
                        Custom
                      </li>
                    </ul>
                  )}
                </div>
              </div>
              {showDateRanges && (
                <div className="grid grid-cols-2 gap-3 ">
                  <div className="mb-[20px]">
                    <label htmlFor="" className="font-[600]">
                      Start Date:
                    </label>
                    <input
                      onChange={(e) => setStartDate(e.target.value)}
                      type="date"
                      name=""
                      id=""
                      className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                    />
                  </div>
                  <div className="mb-[20px]">
                    <label htmlFor="" className="font-[600]">
                      End Date:
                    </label>
                    <input
                      onChange={(e) => setEndDate(e.target.value)}
                      type="date"
                      name=""
                      id=""
                      className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                    />
                  </div>
                </div>
              )} */}

              <div className="flex justify-end">
                {loading ? (
                  <div className="bg-[#2195f3d9] flex items-center gap-2 px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                    <RotatingLines
                      visible={true}
                      height="16"
                      width="16"
                      color="black"
                      strokeColor="white"
                      strokeWidth="5"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />{" "}
                    Submitting
                  </div>
                ) : (
                  <button    
                    onClick={()=>getCashierSales()}                
                    className="bg-[#2196F3] px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white"
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashierSales;
